import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

import {
  Container,
  ImageOne,
  ImageTwo,
  ContentCard,
  Title,
  Description,
} from './Version2.css.js';

const Version2 = ({ title, description, imageOne, imageTwo }) => {
  return (
    <Container>
      <ImageOne
        backgroundImageUrl={imageOne} alt=""
      />

      <ContentCard>
        <Title>{title}</Title>

        <Description>{description}</Description>
      </ContentCard>

      <ImageTwo
        backgroundImageUrl={imageTwo} alt=""
      />
    </Container>
  );
}

Version2.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  imageOne: PropTypes.string.isRequired,
  imageTwo: PropTypes.string.isRequired,
}

export default Version2;
